export const environment = {
  production: true,
  apiBaserURL: 'https://alan-ortega-restaurant-reservation.onrender.com',
};
